@use "ui/styles/fontsOld";

.wrapper {
    position: relative;

    :global {
        .confirmation {
            strong {
                font-weight: fontsOld.$medium-weight;
            }

            .confirmation-input {
                margin-top: 24px;
            }
        }
    }
}